export type Eip1559GasDetails = {
  priority_fee: number;
  max_fee: number;
  estimation_seconds: number;
};

export type GasPrice = {
  slow: number;
  standard: number;
  fast: number;
};

export type OptimisticGasPrice = {
  l1: number;
  l2: number;
  fixed_overhead: number;
  dynamic_overhead: number;
};

export type Eip1559GasPrice = {
  base_fee: number;
  slow: Eip1559GasDetails;
  standard: Eip1559GasDetails;
  fast: Eip1559GasDetails;
};

export type GasData = {
  internalChainId: string;
  type: string;
  updatedAt: string;
  info: GasPrice | Eip1559GasPrice | OptimisticGasPrice;
};

export interface FormattedGasData extends Omit<GasData, "info"> {
  info: GasPrice;
}
